export default __webpack_public_path__ + "static/media/Logo-NEXT-Business-positivo.69c5aecc.svg";